<script setup lang="ts">
import CogSettings from '@/assets/components/maintenance/cogs-settings.svg'

const { t } = useI18n()
const loading = ref(false)

function handleReload() {
  if (loading.value)
    return
  loading.value = true
  window?.location?.reload()
}
</script>

<template>
  <div class="min-h-screen flex flex-col justify-center items-center -mt-24">
    <CogSettings class="mb-8 h-40 max-w-full" />
    <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold text-center text-gray-700 mb-4">
      {{ t('maintenance.title') }}
    </h1>
    <p class="text-center text-gray-500 text-lg md:text-xl lg:text-2xl mb-8">
      {{ t('maintenance.description') }}
    </p>
    <div class="flex space-x-4">
      <button
        v-loading="loading"
        type="button"
        class="border-2 border-gray-800 text-black font-bold py-3 px-6 rounded"
        :class="{ 'opacity-50 cursor-not-allowed': loading }"
        :disabled="loading"
        @click.prevent="handleReload"
      >
        {{ t('maintenance.reload') }}
      </button>
    </div>
  </div>
</template>

<style scoped lang="postcss">

</style>
